import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, CircularProgress, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { parseApiError, isErrorResponse } from '../../../../../utils/apiErrors';
import { useChangeState } from '../../hooks';

export interface Props {
  strategyId: string;
  active: boolean;
  onUpdate: () => void;
  onClose: () => void;
}

export function DeleteDialog({ strategyId, active, onUpdate, onClose }: Props) {
  const [error, setError] = useState('');

  const { mutateAsync, isPending: isLoading } = useChangeState();

  const onSubmit = async () => {
    const data = {
      id: strategyId,
      active: !active,
    };

    try {
      const result = await mutateAsync(data);

      if (isErrorResponse(result)) {
        setError(parseApiError(result));
        return;
      }

      onUpdate();
    } catch (err) {
      setError(parseApiError(err));
    }
  };

  return (
    <Dialog maxWidth="xs" open>
      <DialogTitle align="center">Удаление стратегии</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        Вы уверены, что хотите {active ? 'удалить' : 'активировать'} стратегию?
        <br />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Отмена
        </Button>
        <Button onClick={onSubmit} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Ок
        </Button>
      </DialogActions>
    </Dialog>
  );
}
